var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoader = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  style: {
    margin: "auto",
    background: "none",
    display: "block",
    shapeRendering: "auto"
  },
  width: "60px",
  height: "60px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#cb7bae"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.375s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#f8be6d"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.25s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(60 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#b3cb7b"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.125s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(80 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#84a9c7"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader.6bfd340524199a8da9b6be5245228009.svg";